export default "__VITE_ASSET__6c0be352__"